'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { ReactNode } from 'react'
import { ModalCenteredHeaderIcon } from './modal-centered-header-icon.tsx'
import { ModalCenteredHeaderTitle } from './modal-centered-header-title.tsx'

const ModalCenteredHeaderComponent = ({
  children,
  className,
}: { children: ReactNode; className?: string }) => {
  return (
    <div
      className={cn(
        'w-full flex flex-col justify-center items-center gap-2',
        className
      )}
    >
      {children}
    </div>
  )
}

const ModalCenteredHeaderNamespace = Object.assign(
  ModalCenteredHeaderComponent,
  {
    Icon: ModalCenteredHeaderIcon,
    Title: ModalCenteredHeaderTitle,
  }
)

export { ModalCenteredHeaderNamespace as ModalCenteredHeader }
